<template>
  <v-container class="px-5 my-5">
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-lg">
          <v-card-title
            class="text-h6 grey--text text--darken-3 font-weight-medium pt-8 mx-4"
            style="font-size: 20px !important;"
            >{{$t('identification_types.title')}}
            <v-spacer />
            <v-btn
              color="primary"
              class="mx-2 rounded-lg"
              @click="toggleDrawer()"
            >
              <span style="color: #fff;"> <v-icon>add</v-icon> {{$t('identification_types.drawer.create')}} </span>
            </v-btn>
          </v-card-title>
          <v-divider />
          <template>
            <v-data-table
              :loading="identificationTypesTable.loading"
              :headers="identificationTypesTable.headers"
              :items="identificationTypesTable.items"
              :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
              :items-per-page="identificationTypesTable.pagination.itemsPerPage"
              :no-data-text="$t('subscriptions_report.no_data')"
              :no-results-text="$t('subscriptions_report.no_data')"
            >
              <!-- SHOWS NO DATA -->
              <template v-slot:no-data>
                <div class="text-center pa-5 my-5">
                  <v-img
                    :src="require('@/assets/svg/box_empty.svg')"
                    height="150"
                    max-height="150px"
                    aspect-ratio="1"
                    contain
                  />
                  <div class="grey--text">
                    {{ $t('common.no_data') }}
                  </div>
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn small icon color="primary" @click="editItem(item)">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <!------------------------------------------------->
    <!-- Drawer --------------------------------------->
    <!------------------------------------------------->

    <v-dialog v-model="drawer" persistent max-width="600px">
      <v-card style="border-radius: 16px; padding: 20px;">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="toggleDrawer()">
            {{ $t('goals.close_button') }}
          </v-btn>
          <v-btn :disabled="disabled" color="primary" @click="save">
            {{ $t('goals.save_button') }}
          </v-btn>
        </v-card-actions>
        <v-card-title class="d-flex align-items-center justify-center">
          <span class="text-h7">{{
            update ? $t('identification_types.drawer.update') : $t('identification_types.drawer.create')
          }}</span>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-card-text class="mt-8">
          <v-form ref="form" v-model="valid" lazy-validation>
            <label style="font-weight: bold;">
             {{ $t('identification_types.drawer.name') }}
            </label>
            <v-text-field
              :label="$t('identification_types.drawer.name')"
              v-model="name"
              required
              v-validate="'required'"
              :rules="rules.nameRules"
              data-vv-name="name"
              outlined
              dense
              class="rounded-lg mt-2"
            ></v-text-field>
            <label style="font-weight: bold;">
              {{ $t('identification_types.drawer.countries') }}
            </label>
            <v-autocomplete
              v-model="selectedCountries"
              :items="countries"
              item-value="id"
              item-text="name"
              :label="'Paises'"
              class="rounded-lg mt-2"
              multiple
              clearable
              small-chips
              required
              data-vv-name="selectedCountries"
              outlined
              dense
            >
              <template v-slot:prepend-item>
                <v-list-item ripple>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="all"
                      @change="toggleSelectAll()"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>

            <label style="font-weight: bold;">
              {{ $t('identification_types.drawer.translations') }}
            </label>
            <v-text-field
              :label="$t('identification_types.drawer.es')"
              v-model="languages.es"
              outlined
              dense
              class="rounded-lg mt-4"
            ></v-text-field>
            <v-text-field
              :label="'Ingles'"
              v-model="languages.en"
              outlined
              dense
              class="rounded-lg"
            ></v-text-field>
            <v-text-field
              :label="$t('identification_types.drawer.pt')"
              v-model="languages.pt"
              outlined
              dense
              class="rounded-lg"
            ></v-text-field>
            <v-text-field
              :label="$t('identification_types.drawer.ptpt')"
              v-model="languages.ptpt"
              outlined
              dense
              class="rounded-lg"
            ></v-text-field>
            <v-text-field
              :label="$t('identification_types.drawer.de')"
              v-model="languages.de"
              outlined
              dense
              class="rounded-lg"
            ></v-text-field>

          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import organizationMixin from '@/mixins/organization'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar.vue'

export default {
  name: 'IdentificationTypes',
  mixins: [organizationMixin],
  components: {
    BaseToolbar
  },
  data() {
    return {
      valid: false,
      disabled: true,
      identificationTypesTable: {
        loading: false,
        items: [],
        search: null,
        total: 0,
        pagination: {
          sortBy: ['created_at'],
          sortDesc: [true],
          itemsPerPage: 20
        },
        headers: [
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'id',
            class: 'text-no-wrap blue--text text--darken-4'
          },
          {
            text: this.$t('common.name'),
            align: 'start',
            sortable: true,
            value: 'name',
            class: 'text-no-wrap blue--text text--darken-4'
          },
          {
            text: this.$t('dates.date'),
            align: 'start',
            sortable: true,
            value: 'created_at',
            class: 'text-no-wrap blue--text text--darken-4'
          },
          { text: '', value: 'actions', sortable: false }
        ]
      },
      drawer: false,
      organizations: [],
      name: '',
      variable: '',
      description: '',
      selectedCountries: [],
      all: false,
      update: false,
      identificationTypesToUpdate: null,
      languages: {
        es: '',
        en: '',
        pt: '',
        ptpt: '',
        de: ''
      },
      rules: {
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 10) || 'Name must be less than 10 characters'
        ],
      }
    }
  },
  async created() {
    await this.getCountries()
    console.log({ countries: this.countries })
    await this.getIdentificationTypesData()
  },
  watch: {
    name: {
      async handler() {
        const isValid = await this.$validator.validateAll()
        this.disabled = !isValid
      }
    }
  },
  computed: {
    ...mapGetters({
      identificationTypes: 'identificationTypes/identificationTypes'
    }),
    ...mapState({
      countries: state => state.countries.countries
    })
  },
  methods: {
    ...mapActions({
      getIdentificationTypes: 'identificationTypes/getIdentificationTypes',
      getCountries: 'countries/getCountries',
      createIdentificationType: 'identificationTypes/createIdentificationType',
      updateIdentificationType: 'identificationTypes/updateIdentificationType'
    }),
    async getIdentificationTypesData() {
      this.identificationTypesTable.loading = true

      await this.getIdentificationTypes()
      this.identificationTypesTable.items = this.identificationTypes
      this.identificationTypesTable.total = this.identificationTypes.length
      this.identificationTypesTable.loading = false
    },
    async editItem(mergeTag) {
      this.update = true
      this.identificationTypesToUpdate = mergeTag

      const identificationTypesToUpdate = JSON.parse(JSON.stringify(mergeTag))

      this.name = identificationTypesToUpdate.name
      this.selectedCountries = identificationTypesToUpdate.countries.map(country => country.id)
      this.languages = identificationTypesToUpdate.languages ? identificationTypesToUpdate.languages : {
        es: '',
        en: '',
        pt: '',
        ptpt: '',
        de: ''
      }
      this.drawer = true
    },
    toggleDrawer() {
      this.drawer = !this.drawer
      if (!this.drawer) {
        this.name = ''
        this.selectedCountries = []
        this.update = false
      }
    },
    async save() {
      if (this.update) {
        await this.updateIdentificationType({
          id: this.identificationTypesToUpdate.id,
          name: this.name,
          countries: this.selectedCountries,
          languages: this.languages
        })
        await this.getIdentificationTypesData()
        this.toggleDrawer()
        return
      }
      await this.createIdentificationType({
        name: this.name,
        countries: this.selectedCountries,
        languages: this.languages
      })
      await this.getIdentificationTypesData()
      this.toggleDrawer()
      this.toggleDrawer()
    },
    toggleSelectAll() {
      if (!this.all) {
        this.selectedCountries = []
        return
      }
      this.selectedCountries = []
      this.countries.forEach(org => this.selectedCountries.push(country.id))
    }
  }
}
</script>
